import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import VueMarkdownWithAnchors from '@/components/VueMarkdownWithAnchors.vue';
import Loading from '@/components/Loading.vue';
const blobsModule = namespace('blobs');
let StarshipChapter = class StarshipChapter extends Vue {
    constructor() {
        super(...arguments);
        this.chapterMap = {
            introduction: 'Introduction',
            stepByStep: 'Step-By-Step Starships',
            deployments: 'Deployments',
            starships: 'Starships',
            modifications: 'Modifications',
            equipment: 'Equipment',
            customization: 'Customization Options',
            abilityScores: 'Using Ability Scores',
            adventuring: 'Adventuring',
            combat: 'Combat',
            generatingEncounters: 'Generating Encounters',
            conditions: 'Appendix A: Conditions',
            changelog: 'Changelog'
        };
    }
    created() {
        this.fetchStarshipBlob(this.blobName);
    }
    fetchData() {
        this.fetchStarshipBlob(this.blobName);
    }
    get title() {
        return this.blobName + ' | SOTG' + Vue.prototype.$titleSuffix;
    }
    get blobName() {
        return this.chapterMap[this.chapter];
    }
    get blob() {
        const blob = this.starshipBlobs[this.blobName];
        return blob && blob.replace(/\ufffd/g, ' - ');
    }
};
__decorate([
    blobsModule.State
], StarshipChapter.prototype, "starshipBlobs", void 0);
__decorate([
    blobsModule.Action
], StarshipChapter.prototype, "fetchStarshipBlob", void 0);
__decorate([
    Prop(String)
], StarshipChapter.prototype, "chapter", void 0);
__decorate([
    Watch('$route')
], StarshipChapter.prototype, "fetchData", null);
StarshipChapter = __decorate([
    Component({
        components: {
            VueMarkdownWithAnchors,
            Loading
        }
    })
], StarshipChapter);
export default StarshipChapter;
